import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';

export type TagListData = AnyObject

export type TagListResponse = TagListData

export type TagListGetParams = PaginationProps & {
  orderByColumn?: 'id' | 'name' | 'createdAt' | 'updatedAt';
  name?: string;
}

export const tagList = (payload: TagListGetParams): Action<TagListGetParams> => ({
  type: actions.tagListTrigger.toString(),
  payload,
});

export const tagListClear = (): Action => ({
  type: actions.tagListClear.toString(),
});

export function* tagListRequestSaga({ payload }: Action<TagListGetParams>) {
  yield put({
    type: actions.tagListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.tagListError.toString(),
      payload: {
        message: 'TagList: Parameters not passed.',
      },
    });

    return;
  }

  const { roles, ...restParams } = payload;

  const params = new URLSearchParams(Object.entries(restParams).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/tags?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TagListData, TagListResponse>(
    response,
    actions.tagListSuccess.toString(),
    actions.tagListError.toString(),
    false,
    (tagListData) => tagListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.tagListTrigger.toString(),
    defaultProcessingSaga(
      tagListRequestSaga,
      {
        error: actions.tagListError.toString(),
        locationCancel: actions.tagListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.tagListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.tagListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.tagListErrorReset.toString(),
    });
  });
}
